module.exports = __webpack_public_path__ + "img/x-circle-fill.6713d0a7.svg";